/* eslint-disable no-undef */
$(document).ready(function(){
  var ckScript = document.createElement('script');
  ckScript.setAttribute('src','./assets/js/ckeditor/ckeditor.js');
  ckScript.innerText = ' CKEDITOR.config.forcePasteAsPlainText = true; ';
  document.body.appendChild(ckScript);
});
